/**
 * Shared utilities for the support inbox Preact components.
 */

/**
 * Human-readable relative time in Hungarian (e.g. "5 perce").
 * @param {string|null} iso — ISO 8601 timestamp
 * @returns {string}
 */
export function timeAgo(iso) {
  if (!iso) return ''
  const diff = Math.floor((Date.now() - new Date(iso)) / 1000)
  if (diff < 60)    return 'most'
  if (diff < 3600)  return `${Math.floor(diff / 60)} perce`
  if (diff < 86400) return `${Math.floor(diff / 3600)} órája`
  const days = Math.floor(diff / 86400)
  return days < 7
    ? `${days} napja`
    : new Date(iso).toLocaleDateString('hu-HU', { month: 'short', day: 'numeric' })
}

/**
 * Compact relative time for list rows (e.g. "5 p", "2 ó", "3 n").
 */
export function timeAgoShort(iso) {
  if (!iso) return ''
  const diff = Math.floor((Date.now() - new Date(iso)) / 1000)
  if (diff < 60)    return 'most'
  if (diff < 3600)  return `${Math.floor(diff / 60)} p`
  if (diff < 86400) return `${Math.floor(diff / 3600)} ó`
  const days = Math.floor(diff / 86400)
  return days < 7
    ? `${days} n`
    : new Date(iso).toLocaleDateString('hu-HU', { month: 'short', day: 'numeric' })
}

// Avatar palette — deterministic colour per name
const AVATAR_PALETTE = [
  '#4f7ef8', '#7c3aed', '#0891b2', '#059669', '#d97706',
  '#dc2626', '#db2777', '#6366f1', '#0284c7', '#16a34a',
]

/**
 * Returns a hex colour from the palette based on a string key.
 * @param {string|null} name
 * @returns {string}
 */
export function avatarColor(name) {
  if (!name) return AVATAR_PALETTE[0]
  let sum = 0
  for (let i = 0; i < name.length; i++) sum += name.charCodeAt(i)
  return AVATAR_PALETTE[sum % AVATAR_PALETTE.length]
}

/**
 * Human-readable file size (e.g. "1.2 MB").
 * @param {number} bytes
 * @returns {string}
 */
export function formatBytes(bytes) {
  if (!bytes || bytes === 0) return '0 B'
  const units = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  return `${(bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1)} ${units[i]}`
}
